module.exports = __webpack_public_path__ + "static/media/not-found-image.487748ab.png";